import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const SharepointFilesActions = {
  createSharepointFile: async (_, { docketEntryId, sharepointUrl }) => {
    return axiosRequest.
      post(`/docket_entries/${docketEntryId}/sharepoint_files`, { sharepoint_url: sharepointUrl }).
      then(({ data }) => data).
      catch(handleError)
  },

  deleteSharepointFile: async (_, sharepointFileId) => {
    return axiosRequest.
      delete(`/docket_entries/sharepoint_files/${sharepointFileId}`).
      then(({ data }) => data).
      catch(handleError)
  },

  getSharepointFileThumbnail: async (_, sharepointFileId) => {
    return axiosRequest.
      get(`/docket_entries/sharepoint_files/${sharepointFileId}/thumbnail`).
      then(({ data }) => data).
      catch(handleError)
  },

  validateSharepointFile: async (_, sharepointUrl) => {
    return axiosRequest.
      post('/docket_entries/sharepoint_files/validate', { sharepoint_url: sharepointUrl }).
      then(({ data }) => data).
      catch(handleError)
  },
}
